import { Inject, inject, Injectable } from '@angular/core';

import { Network } from '@capacitor/network';

import { fromEvent, Observable, Subscription } from 'rxjs';

import { GlobalsInterface } from '../../types';
import { GuardService } from '../guard';
import { NotificationsService } from '../notifications/notifications.service';
import { ToastService } from '../toast/toast.service';
import { ClientUserService } from '../users';

@Injectable({
    providedIn: 'root'
})
export class NetworkService {
    clientUserService = inject(ClientUserService);
    proUserService = inject(GuardService);

    globals!: GlobalsInterface;

    onlineEvent: Observable<Event> | undefined;
    offlineEvent: Observable<Event> | undefined;

    subscriptions: Subscription[] = [];

    connectionStatusMessage: string | undefined;
    connectionStatus: string | undefined;

    constructor(
        private toastService: ToastService,
        private nService: NotificationsService,
        @Inject('globals') globals: GlobalsInterface
    ) {
        this.globals = globals;
    }

    async checkConnection() {
        const status = await Network.getStatus();

        if (!status.connected) {
            this.offline();
        }
    }

    capacitorNetworkWatchInit() {
        Network.addListener('networkStatusChange', status => {
            console.log('Network status changed', status);
            if (status.connected) {
                this.toastService.persistentNoticeDismiss();
                this.online();
            } else {
                this.toastService.persistentNotice({
                    message: 'You are offline. Please reconnect to the internet to continue using this app.'
                });
                this.offline();
            }
        });
    }

    capacitorNetworkWatchStop() {
        Network.removeAllListeners();
    }

    offline() {
        const user = this.globals.appType === 'client' ? this.clientUserService.user() : this.proUserService.user();
        if (user !== null) {
            this.nService.stopNotificationSubscription();
        }
    }

    online() {
        const user = this.globals.appType === 'client' ? this.clientUserService.user() : this.proUserService.user();
        if (user !== null) {
            this.nService.startNotificationSubscription();
        }
    }

    browserNetworkWatchInit() {
        this.onlineEvent = fromEvent(window, 'online');
        this.offlineEvent = fromEvent(window, 'offline');

        this.subscriptions.push(
            this.onlineEvent.subscribe(() => {
                this.online();
            })
        );

        this.subscriptions.push(
            this.offlineEvent.subscribe(() => {
                this.offline();
            })
        );
    }

    browserNetworkWatchStop() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
